import { render, staticRenderFns } from "./MyTickets_TravelSlot.vue?vue&type=template&id=6a574a5a&"
import script from "./MyTickets_TravelSlot.vue?vue&type=script&lang=js&"
export * from "./MyTickets_TravelSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports